//------------------------------------------------------------------------------
//
// OAIDC Settings
//
// Defines configuration for interacting with our SSO system based on the
// current URL.
//
//------------------------------------------------------------------------------

let environment = '';

switch (window.location.origin) {
	case 'https://rdap-web.apnic.net':
		environment = 'production';
		break;
	default:
		environment = 'other';
}

export const OIDC_ROOT = environment === 'production'
	? 'https://login.apnic.net'
	: 'https://beta-login.svc.tst.apnic.int';

export const USER_MANAGEMENT_SERVICE = environment === 'production'
	? 'https://profile.apnic.net'
	: 'https://user-management.svc.tst.apnic.int';

export const OAIDC_SETTINGS = {
	authority: `${OIDC_ROOT}/oauth2/apnic`,
	client_id:  environment === 'production' ? '0oa1f5lczry3A5a8b3l7' : '0oa378poo0FXBNT8F0x7',
	redirect_uri: window.location.origin + '/auth-callback',
	response_type: 'id_token',
	scope: 'openid email',
	automaticSilentRenew: true,
	silent_redirect_uri: window.location.origin + '/silent-renew-oidc.html'
};

export const isTestEnv = environment === 'other';

export const profileSectionURLs =
	environment === 'production'
		? {
			personalSettingsURL: 'https://profile.apnic.net',
			passwordSecurityURL: 'https://profile.apnic.net/password-security',

			myApnicDashboardURL: 'https://my.apnic.net',
			linkExistingMembership:
				'https://resources.apnic.net/auth/nm-landing-page.html',
			membershipApplication: 'https://www.apnic.net/get-ip/apnic-membership',
		}
		: {
			personalSettingsURL: 'https://user-management.svc.tst.apnic.int',
			passwordSecurityURL:
				'https://user-management.svc.tst.apnic.int/password-security',
			myApnicDashboardURL: 'https://myapnic-portal.svc.tst.apnic.int',
			linkExistingMembership:
				'https://myapnic-facade.svc.tst.apnic.int/auth/nm-landing-page.html',
			membershipApplication:
				'https://membership-application.svc.tst.apnic.int',
		};
